export default "__VITE_ASSET__0htnO74l__"